module.exports = __webpack_public_path__ + "static/img/zhzj.ed3d0da9.png";